import React, { FC } from 'react'
import './index.scss'

interface IProps {
  className?: string;
}

/** 统一展示餐品与分组的必选角徽，容器负责具体定位。 */
const RequiredBadge: FC<IProps> = ({ className = 'required-product-badge' }) => (
  <span className={`required-badge ${className}`}>{i18n.t('cart.requiredProductTag')}</span>
)

export default RequiredBadge
